// extracted by mini-css-extract-plugin
export default {"root":"TabsSelector__root--1LEoT"};